import { get, post, patch, del } from './api';
// AI Chat conversation type
export interface Conversation {
  id: string;
  title: string | null;
  createdAt: string;
  updatedAt: string;
}

// AI Chat message type
export interface Message {
  id: string;
  role: 'user' | 'assistant' | 'system' | 'tool';
  content: string;
  toolCalls?: unknown;
  toolCallId?: string;
  toolName?: string;
  createdAt: string;
  title?: string | null;
}

// Autocomplete suggestion type
export interface AutocompleteSuggestion {
  title?: string;
  description?: string;
  priority?: string;
  dueDate?: string;
  remindAt?: string;
  projectId?: string;
  assigneeId?: string;
  labels?: string[];
  isPrivate?: boolean;
}

export const aiChatApi = {
  createConversation: (data?: { title?: string }) =>
    post<Conversation>('/ai-chat/conversations', data),

  listConversations: (params?: Record<string, unknown>) =>
    get<Conversation[]>('/ai-chat/conversations', params),

  getConversation: (id: string) =>
    get<Conversation & { messages: Message[] }>(`/ai-chat/conversations/${id}`),

  updateConversation: (id: string, data: { title: string }) =>
    patch<Conversation>(`/ai-chat/conversations/${id}`, data),

  deleteConversation: (id: string) =>
    del<void>(`/ai-chat/conversations/${id}`),

  sendMessage: (conversationId: string, content: string) =>
    post<Message>(`/ai-chat/conversations/${conversationId}/messages`, { content }),

  autocomplete: (description: string) =>
    post<AutocompleteSuggestion>('/ai-chat/autocomplete', { description }),
};
